
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextSeo } from 'next-seo'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import Layout from '@/app/common/components/Layout'
import config from '@/config'
import AppraisalFlow from '@/domains/appraisal/components/AppraisalFlow'
import {
  isAiAppraisalRemotelyConfigurable,
  useAiAppraisalToggle,
} from '@/helpers/aiAppraisalToggle'
import { createGetServerSideProps } from '@/helpers/createGetServerSideProps'
import useHtmlClassNames from '@/helpers/useHtmlClassNames'

export default function WertCheckPage() {
  const { t } = useTranslation('wertCheck')
  useHtmlClassNames('bg-fill-senary')
  const router = useRouter()
  const enabled = useAiAppraisalToggle()

  useEffect(() => {
    // Visitors outside the rollout cohort don't get the flow via a shared
    // link either — keeps the catalogue cohort clean for comparison.
    if (enabled === false) {
      router.replace('/')
    }
  }, [enabled, router])

  return (
    <Layout>
      <NextSeo noindex nofollow title={t('page_title')} />
      {enabled && <AppraisalFlow />}
    </Layout>
  )
}

 const _getServerSideProps = createGetServerSideProps({
  getServerSideProps: () => {
    // Without the env flag or a Firebase Remote Config setup the page does
    // not exist; with Firebase configured the client-side rollout toggle
    // decides.
    if (!config.aiAppraisalEnabled && !isAiAppraisalRemotelyConfigurable()) {
      return { notFound: true }
    }
  },
})


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/wert-check/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  